import React from "react";
import { useTranslation } from "react-i18next";
import { IListProps } from "../../../interfaces/inputs";
import {
  ListContainer,
  ListDiv,
  Item,
} from "./SelectStyles";
import { ListItem } from "../useFilters";
import Checkbox from "../Input/CheckBox";

const List: React.FC<IListProps> = ({ list, toggleItem, selectedItems, relativeStyle }) => {
  const { t } = useTranslation();
  return (
    <ListContainer relativeStyle={relativeStyle || false}>
      {selectedItems.length > 0 && (
        <>
          {selectedItems.map((item: ListItem) => (
            <Item
              key={item.id}
              onClick={() => toggleItem(item.id, item.key)}
              selected={item.selected}
            >
              <Checkbox
                checkboxKey={`${item.id}1`}
                isChecked={true}
                onChange={() => toggleItem(item.id, item.key)}
              />
              {t(item.title)}
            </Item>
          ))}
          <ListDiv />
        </>
      )}

      {list.length > 0 ? (
        list
          .filter((item) => !item.selected)
          .map((item: ListItem) => (
            <>
              <Item key={item.id} selected={item.selected}>
                <Checkbox
                  checkboxKey={`${item.id}2`}
                  isChecked={false}
                  onChange={() => toggleItem(item.id, item.key)}
                />
                {t(item.title)}
              </Item>
              <ListDiv />
            </>
          ))
      ) : (
        <Item>{t("admin.table.noResults")}</Item>
      )}
    </ListContainer>
  );
};

export default List;
